{
  "menu": {
    "trigger": "帳號選單",
    "myProfile": "我的資料",
    "mySecurity": "帳號與安全",
    "myRoles": "角色與權限",
    "applyToHost": "申請成為競賽主辦方",
    "signOut": "登出",
    "manageEvent": "活動管理：{{title}}"
  },
  "profile": {
    "title": "我的資料",
    "description": "檢視並編輯您自己的個人資料。",
    "email": "電子郵件",
    "emailVerified": "已驗證",
    "emailUnverified": "尚未驗證",
    "displayName": "顯示名稱",
    "organizationDisplayName": "單位／組織（選填）",
    "organizationHint": "此資訊由您自行填寫，不代表平台認證，也不代表任何已驗證的主辦單位或管理身分。",
    "locale": "語言",
    "timezone": "時區",
    "timezoneHint": "目前顯示為：{{formatted}}",
    "save": "儲存變更",
    "saving": "儲存中…",
    "saved": "資料已更新。",
    "error": "無法儲存您的資料，請再試一次。"
  },
  "security": {
    "title": "帳號與安全",
    "description": "管理您的密碼與目前已登入的裝置。",
    "passwordSection": {
      "title": "密碼",
      "currentPassword": "目前密碼",
      "newPassword": "新密碼",
      "newPasswordHint": "至少需要 10 個字元。",
      "change": "修改密碼",
      "changing": "修改中…",
      "success": "密碼已更新。為保護帳號安全，其他裝置可能需要重新登入。",
      "wrongCurrentPassword": "目前密碼不正確。",
      "genericError": "無法修改密碼，請再試一次。",
      "oidcOnlyTitle": "由 Identity Provider 管理",
      "oidcOnlyDescription": "此帳號透過外部 Identity Provider 登入，沒有可在此修改的本地密碼。"
    },
    "sessionsSection": {
      "title": "已登入的裝置",
      "description": "目前已登入您帳號的裝置。",
      "current": "此裝置",
      "lastSeen": "最近活動於 {{when}}",
      "revoke": "登出",
      "revoking": "登出中…",
      "revokeOthers": "登出其他裝置",
      "revokeOthersDisabledReason": "目前沒有其他登入裝置。",
      "revokeOthersConfirmTitle": "登出其他裝置？",
      "revokeOthersConfirmDescription": "此操作會立即將您的帳號在除了此裝置以外的所有裝置上登出。",
      "empty": "沒有其他已登入的裝置。",
      "unknownDevice": "未知裝置",
      "revokeOthersSuccess": "其他裝置已登出。"
    },
    "emailSection": {
      "title": "Email",
      "current": "目前的 Email：{{email}}",
      "pending": "已送出變更請求，等待驗證：{{email}}（連結將於 {{expiresAt}} 過期）",
      "newEmail": "新的 Email",
      "currentPassword": "目前密碼",
      "request": "送出變更請求",
      "requesting": "送出中…",
      "success": "驗證信已寄出，請至新的 Email 收信並點擊連結完成變更。",
      "wrongCurrentPassword": "目前密碼不正確。",
      "alreadyInUse": "此 Email 已被其他帳號使用。",
      "genericError": "無法送出變更請求，請再試一次。",
      "oidcOnlyDescription": "此帳號透過外部 Identity Provider 登入，僅需再次確認登入狀態即可送出變更請求。"
    },
    "emailVerify": {
      "title": "確認 Email 變更",
      "description": "請確認要將您的登入 Email 變更為此連結所指定的新地址。",
      "invalidLink": "此連結無效，請重新從帳號設定頁申請變更 Email。",
      "confirm": "確認變更",
      "confirming": "確認中…",
      "success": "Email 已成功變更為 {{email}}。",
      "failed": "此連結無效或已過期，請重新申請變更 Email。"
    },
    "dataSection": {
      "title": "個人資料匯出與帳號刪除",
      "description": "匯出平台所保存與您有關的個人資料，或申請刪除您的帳號。",
      "exportTitle": "匯出我的資料",
      "exportDescription": "下載一份 JSON 檔案，包含您的基本資料、競賽角色、隊伍成員身分、投稿、學生資格驗證紀錄、評審相關資料等。",
      "export": "匯出資料",
      "exporting": "匯出中…",
      "exportError": "無法匯出資料，請再試一次。",
      "erasureTitle": "刪除我的帳號",
      "erasureDescription": "申請刪除帳號後，將由平台管理員審核。核准後，您的姓名、Email 等個人識別資訊將被去識別化，登入憑證將被永久刪除；已產生的競賽歷史紀錄（投稿、分數、排名等）將保留但去識別化，以維護競賽結果的完整性。此操作無法復原。",
      "erasurePending": "您已送出帳號刪除申請，正在等待平台管理員審核。",
      "cancelRequest": "取消申請",
      "cancelling": "取消中…",
      "requestErasure": "申請刪除帳號",
      "confirmTitle": "確認申請刪除帳號？",
      "confirmDescription": "此操作無法復原。核准後您將無法再登入此帳號。",
      "currentPassword": "目前密碼",
      "reasonLabel": "原因（選填）",
      "wrongCurrentPassword": "目前密碼不正確。",
      "requestError": "無法送出申請，請再試一次。",
      "submitting": "送出中…",
      "confirmSubmit": "確認申請刪除"
    }
  },
  "roles": {
    "title": "角色與權限",
    "description": "此畫面僅供查看，不提供任何編輯功能。若您認為角色有誤，請聯絡該競賽的管理員或平台管理員。",
    "platformRoleTitle": "平台角色",
    "platformRoleNone": "無平台層級角色。",
    "competitionRolesTitle": "競賽角色",
    "competitionRolesEmpty": "您目前未擔任任何競賽的角色。",
    "loadError": "無法載入角色資訊，請再試一次。"
  }
}
